import React, { PureComponent } from "react";
import Icon from "@mdi/react";
import { mdiChevronRight, mdiChevronLeft } from "@mdi/js";
import {
  Dropdown as BootStrapDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem as DropdownMenuItem,
} from "reactstrap";
import styles from "./styles.scss";

export interface DropdownWithButtonsItem {
  name: string;
  key?: string;
}

export interface DropdownWithButtonsProps {
  style?: object;
  className?: string;
  onSelectItem(item: DropdownWithButtonsItem, index: number): void;
  onSelectRightChevron(index: number): void;
  onSelectLeftChevron(index: number): void;
  selectedIndex: number;
  items: DropdownWithButtonsItem[];
}

export interface DropdownWithButtonsState {
  openDropdown: boolean;
}

class DropdownWithButtons extends PureComponent<DropdownWithButtonsProps, DropdownWithButtonsState> {
  static defaultProps = {
    onSelectItem: () => {},
    selectedIndex: 0,
    items: [],
  };

  constructor(props: DropdownWithButtonsProps) {
    super(props);
    this.state = {
      openDropdown: false,
    };
  }

  toggleDropdown = () => {
    this.setState({ openDropdown: !this.state.openDropdown });
  };

  render() {
    const { openDropdown } = this.state;
    const { style, className, onSelectItem, selectedIndex, items, onSelectRightChevron, onSelectLeftChevron } =
      this.props;
    const selectedItem = items[selectedIndex];
    return (
      <div className={`rotoql-dropdown-buttons ${className}`}>
        <button
          className="rotoql-dropdown-buttons__chevron-button rotoql-dropdown-buttons__chevron-button--left"
          onClick={() => onSelectLeftChevron(selectedIndex)}
          disabled={selectedIndex === 0}
        >
          <Icon path={mdiChevronLeft} size="25px" color="#515151" />
        </button>
        <BootStrapDropdown isOpen={openDropdown} toggle={this.toggleDropdown}>
          <DropdownToggle block style={style} className="rotoql-dropdown-buttons__button">
            <div className="rotoql-dropdown-buttons__button--name">{selectedItem.name}</div>
          </DropdownToggle>
          <DropdownMenu className="rotoql-dropdown-buttons__menu">
            {items.map((item: DropdownWithButtonsItem, index: number) => (
              <DropdownMenuItem
                key={index}
                className={`rotoql-dropdown-buttons__item ${
                  index === selectedIndex ? "rotoql-dropdown-buttons__item--active" : ""
                }`}
                onClick={() => onSelectItem(item, index)}
              >
                {item.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenu>
        </BootStrapDropdown>
        <button
          className="rotoql-dropdown-buttons__chevron-button rotoql-dropdown-buttons__chevron-button--right"
          onClick={() => onSelectRightChevron(selectedIndex)}
          disabled={selectedIndex === items.length - 1 ? true : false}
        >
          <Icon path={mdiChevronRight} size="25px" color="#515151" />
        </button>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}

export default DropdownWithButtons;
